import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
//import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AdvanceGridviewComponent } from 'src/app/shared/components/advance-gridview/advance-gridview.component';
import { DropdownMultiselectComponent } from 'src/app/shared/components/dropdown-multiselect/dropdown-multiselect.component';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-unlock-invoice',
  templateUrl: './unlock-invoice.component.html',
  styleUrls: ['./unlock-invoice.component.css']
})

export class UnlockInvoiceComponent implements OnInit {

  docTypeList: any = [];
  processTypeList: any = [];
  strURN: string = '';
  //selectedDocumentType: any;
  // selectedProcessType: any;
  lstURNData: any = [];
  chnageTypeColumnsToHide: any = ['DOCUMENT_DETAIL_ID', 'PROCESS_ID'];
  modalReference: any;
  isDataFound: boolean = false;
  isWorkItemDateRangeHasValue = false;
  isDisplayTransactionData = false;
  isDateRangeHasValue = false;
  maxDate = new Date();
  workItemCreationDateRange = new FormGroup({
    work_item_start_date: new FormControl(),
    work_item_end_date: new FormControl(),
  });

  lstHeaders = [];
  lstHeaders_log = [];

  advanceSearchDynamicFields: any = [];
  advanceSearchStaticFields: any = {
    URN: "",
    Priority: "",
    SOURCE: "",
    FROM_EMAIL: "",
    Created_Dt_From: "",
    Created_Dt_To: ""
  };

  invoiceCreationDateRange = new FormGroup({
    start_date: new FormControl(),
    end_date: new FormControl(),
  });

  @ViewChild('invoiceSubmittedModal') invoiceSubmittedModal: ElementRef;
  @ViewChild('gridTransactionData') gridAllocationData: AdvanceGridviewComponent;
  @ViewChild('ddlDocselect') ddlDocmultiselect: DropdownMultiselectComponent;
  @ViewChild('ddlProcessmultiselect') ddlProcessmultiselect: DropdownMultiselectComponent;

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private route: Router,
    private encryptDecryptservice:EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) {
    //wowService.init();
  }

  ngOnInit(): void {
    this.getDocumentTypes();
    this.getProcessTypes();
  }

  getDocumentTypes() {
    this.docTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
    params = params.append('subgroup_id',this.encryptDecryptservice.encryptUsingAES256( this.commonService.selectedSubgroup));
    params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('document-types', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            res.data.forEach((element) => {
              this.docTypeList.push({
                value: element.document_type_id,
                text: element.document_type_name,
                selected: true,
              });
            });
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  getProcessTypes() {
    this.processTypeList = [];
    let params = new HttpParams();
    // params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('project_id',this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
   params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
    this.dataService.getData('process-type', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            res.data.forEach((element) => {
              this.processTypeList.push({
                value: element.process_id,
                text: element.process_name,
                selected: true,
              });
            });
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  // async onSelectDocumentType() {
  //   await this.getAdvanceSearchFields();
  // }

  // async getAdvanceSearchFields() {

  //   let reqData = {
  //     project_id: this.commonService.selectedProject,
  //     document_type_ids: this.selectedDocumentType,
  //   };

  //   await this.dataService.getDataPromise('advanced-search-fields', reqData).then((res) => {
  //     if (res != null && res.data != null) {

  //       this.advanceSearchDynamicFields = res.data;
  //       this.advanceSearchDynamicFields.forEach(async (element) => {
  //         element['search_value'] = '';
  //         if (element.control_type == 'TEXTBOX') {
  //           element.value_type = element.validation_type == 'NUMERIC' ? 'number' : 'text';
  //         }
  //         if (element.control_type == 'DROPDOWN') {
  //           element.options = await this.commonService.getDropdownData(element.field_mapping_detail_id);
  //           element.options.splice(0, 0, { id: 0, name: '-- Select --' });
  //         }
  //       });
  //     }
  //   });
  // }

  getLockedURNs() {

    this.lstURNData = [];
    this.lstHeaders = [];
    let searchColumns = {};
    this.isDataFound = false;
    this.isDisplayTransactionData = false;

    // this.advanceSearchDynamicFields.forEach((field) => {
    //   if (field.search_value != '') {
    //     if (field.control_type == 'DATE') {
    //       field.search_value = this.commonService.dateFormating(
    //         field.search_value
    //       );
    //     }
    //     searchColumns[field.db_column_name] = field.search_value.toString();
    //   }
    // });

    let invalidSubmitMsg = '';
    this.ddlDocmultiselect.onDropdownOptionClick();
    if (this.ddlDocmultiselect.selectedValues.length <= 0) {
      invalidSubmitMsg += '- Please fill the required field(s).\r <br/>';
      invalidSubmitMsg += '- Select atleast one Work Item Type.\r <br/>';
    }
    this.ddlProcessmultiselect.onDropdownOptionClick();
    if (this.ddlProcessmultiselect.selectedValues.length <= 0) {
      invalidSubmitMsg += invalidSubmitMsg == '' ? '- Please fill the required field(s).\r <br/>' : '';
      invalidSubmitMsg += '- Select atleast one Queue.\r <br/>';
    }

    if (invalidSubmitMsg != '') {
      this.commonService.showMessageBox(invalidSubmitMsg, 'Alert');
    }
    else {

      let invoice_dateRange: any = { start_date: '', end_date: '' };
      let invoice_dt: string = "";

      if (this.isDateRangeHasValue) {
        invoice_dateRange = {
          start_date: this.commonService.dateFormating(
            this.invoiceCreationDateRange.value.start_date
          ),
          end_date: this.commonService.dateFormating(
            this.invoiceCreationDateRange.value.end_date
          ),
        };
        invoice_dt = invoice_dateRange.start_date + '/' + invoice_dateRange.end_date;
      }
      let create_dateRange: any = { start_date: '', end_date: '' };

      let create_dt: string = "";
      if (this.isWorkItemDateRangeHasValue) {
        create_dateRange = {
          start_date: this.commonService.dateFormating(
            this.workItemCreationDateRange.value.work_item_start_date
          ),
          end_date: this.commonService.dateFormating(
            this.workItemCreationDateRange.value.work_item_end_date
          ),
        };
        create_dt = create_dateRange.start_date + '/' + create_dateRange.end_date;
      }
      let parentSearchField = this.advanceSearchStaticFields;
      let priority = [];
      if (parentSearchField.Priority != "") {
        priority.push(parentSearchField.Priority)
      }

      let obj = {
        action: "FILTER",
        // projectId: this.commonService.selectedProject,
        project_Id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject),
        document_type_ids: this.ddlDocmultiselect.selectedValues.toString(),
        process_ids: this.ddlProcessmultiselect.selectedValues.toString(),
        urn: this.strURN,
        durationCreateDate: create_dt,
        durationInvoiceDate: invoice_dt,
        // role_id: this.commonService.selectedRole,
        roleid:  this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole),
        search_columns: searchColumns,
        priority: [],
        source: "",
        from_email: "",
        date_range: null
      };

      if (this.commonService.readObject(parentSearchField) != null) {

        if (parentSearchField.URN != "") {
          obj.urn = parentSearchField.URN;
          //searchColumns["d.urn"] = obj.urn;
        }
        obj.priority = priority;
        obj.source = parentSearchField.SOURCE;
        obj.from_email = parentSearchField.FROM_EMAIL;
        if (this.commonService.readInput(parentSearchField.Created_Dt_From) != "" && this.commonService.readInput(parentSearchField.Created_Dt_To) != "")
          obj.date_range = { "start_date": parentSearchField.Created_Dt_From, "end_date": parentSearchField.Created_Dt_To };
      }

      if (this.lstURNData.length > 0) {
        this.lstURNData.splice(0, this.lstURNData.length)
        //  this.isDisplayTransactionData = false;
      }
      // this.commonService.setUserInfoToLocalStorage('allocationGridSearchField', JSON.stringify(this.advanceSearchDynamicFields));
      this.memorystore.setItem('allocationGridSearchField', JSON.stringify(this.advanceSearchDynamicFields));
      this.dataService.postData('invoice/get-locked-invoices', obj).subscribe(
        (res) => {
          if (res != null && (res.error_message == null || res.error_message == "")) {
            if (res.data != null) {
              if (res != null && res != undefined && res.data != null && res.data.length > 0) {

                this.lstHeaders = res.data[0].table_sections;
                this.lstHeaders_log.forEach(sec => {
                  sec.section_fields.forEach(f => {
                    let field = this.lstHeaders.find(x => x.section_name == sec.section_name) ?.section_fields.find(y => y.name == f.name);
                    if (field) {
                      field.is_visible = f.is_visible;
                    }
                  });
                });

                this.lstURNData = res.data[0].table_data;

                if (this.lstURNData != undefined && this.lstURNData.length > 0) {
                  this.isDataFound = true;
                  this.isDisplayTransactionData = true;
                } else {
                  this.commonService.showMessageBox('No Data Found', 'Alert');
                  this.isDataFound = false;
                  this.isDisplayTransactionData = false;
                }
              }
              else {
                this.commonService.showMessageBox('No Data Found', 'Queue Change');
                this.isDataFound = false;
              }
            }
            else {
              this.isDataFound = false;
              this.commonService.showMessageBox('No Data Found', 'Queue Change');
            }
          }
          else {
            if (res.errorCode != 0 && res.errorCode == 4000) {
              this.route.navigateByUrl('/unauthorized');
              return;
            }
            if (res.errorCode != 0 && res.errorCode == 3000) {
              this.commonService.showMessageBox("Internal error")
            }
          }

        },
        error => {
          if (error.includes("401")) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
        });
    }
  }

  clearOpenSearch() {

    this.strURN = '';
    this.resetInvoiceCreationDateRange();
    this.resetWorkItemCreationDateRange();
    //this.selectedDocumentType = this.docTypeList.length > 0 ? this.docTypeList[0].value : '';
    if (this.lstURNData.length > 0) {
      this.lstURNData.splice(0, this.lstURNData.length)
    }
    this.isDataFound = false;
    this.isDisplayTransactionData = false;

  }

  onInvoiceCreationDateChanges() {
    if (
      this.invoiceCreationDateRange.value.start_date != '' ||
      this.invoiceCreationDateRange.value.end_date != ''
    ) {
      this.isDateRangeHasValue = true;
    }
  }

  resetInvoiceCreationDateRange() {
    this.invoiceCreationDateRange = new FormGroup({
      start_date: new FormControl(),
      end_date: new FormControl(),
    });
    this.isDateRangeHasValue = false;
  }

  onWorkItemCreationDateChanges() {
    if (
      this.workItemCreationDateRange.value.work_item_start_date != '' ||
      this.workItemCreationDateRange.value.work_item_end_date != ''
    ) {
      this.isWorkItemDateRangeHasValue = true;
    }
  }

  resetWorkItemCreationDateRange() {
    this.workItemCreationDateRange = new FormGroup({
      work_item_start_date: new FormControl(),
      work_item_end_date: new FormControl(),
    });
    this.isWorkItemDateRangeHasValue = false;
  }

  cellClickEvent(event: any) {
    if (event.columnName.toLowerCase() == 'urn') {

      let data = {
        documentDetailId: event.rowData['DOCUMENT_DETAIL_ID'],
        isReadonlyMode: true
      }
      EmmiterService.get("transactionLiteModal").emit(data);

    }
  }

  columnsFilterChangeEvent(lstHeaders: any) {
    this.lstHeaders_log = lstHeaders;
  }

  showModal(modelTemplate, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }

  unlockInvoices() {

    let dataList: any = [];

    this.lstURNData?.forEach((element) => {
      if (element.action_checkbox_button == true) {
        let obj = {
          ProjectId: this.commonService.selectedProject,
          DocumentDetailId: element.DOCUMENT_DETAIL_ID,
          // UserId: this.commonService.getUserInfoFromLocalStorage('userId')
          UserId: this.memorystore.getItem('userId')
        }
        dataList.push(obj);
      }
    });

    if (dataList.length <= 0) {
      this.commonService.showMessageBox('Please select at least one URN to unlock.', 'Unlock Invoice');
    }
    else {

      let initial_params = {
        lstParameter: dataList
      }
      this.dataService.postData('invoice/unlock-invoices', initial_params).subscribe((res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.status != null) {
            this.commonService.showMessageBox('Unlocked invoices  for ' + dataList.length + ' URN(s).', 'Unlock Invoice');
            this.isDataFound = false;
            this.getLockedURNs();
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
    }
  }

  advanceSearchClickEvent(parentSearchField: any) {
    this.advanceSearchStaticFields = parentSearchField;
    this.getLockedURNs();
  }

}
